import React from 'react';
import { useSectionView, trackCustom } from '../lib/pixel';
const rows = [{
  feature: '6 Tomos de Medicina completos',
  a: true,
  b: true,
  c: true
}, {
  feature: '6 Bonos estratégicos',
  a: true,
  b: true,
  c: true
}, {
  feature: 'Tomo Guardia y Emergencias',
  a: false,
  b: true,
  c: true
}, {
  feature: 'Tomo Medicina Interna para el Examen',
  a: false,
  b: true,
  c: true
}, {
  feature: '7 Editables premium',
  a: false,
  b: false,
  c: true
}];
const Check = () => <span style={{
  color: '#0284c7'
}} className="font-black text-base" data-id="element-270">
    ✓
  </span>;
const Dash = () => <span className="text-gray-300 font-black" data-id="element-271">—</span>;
export function ProBusiness() {
  const sectionRef = useSectionView('Comparison Table');
  return <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,251,255) 0%, rgb(224,242,254) 50%, rgb(240,249,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-272">
      <div className="mx-auto max-w-2xl" data-id="element-273">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-274">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-3" style={{
          color: '#0284c7',
          border: '1px solid rgba(2,132,199,0.4)',
          backgroundColor: 'rgba(2,132,199,0.05)'
        }} data-id="element-275">
            📊 Compará los niveles
          </div>
          <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-276">
            ¿Qué incluye{' '}
            <span style={{
            color: '#0284c7'
          }} data-id="element-277">
              cada nivel?
            </span>
          </h2>
          <p className="text-center text-sm text-gray-500 m-0" data-id="element-278">
            Los tres arrancan con los 6 Tomos y 6 Bonos. Elegí hasta dónde
            querés llegar.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-2xl shadow-md mb-6" style={{
        border: '1px solid rgba(2,132,199,0.2)'
      }} data-id="element-279">
          <table className="w-full min-w-[420px] bg-white rounded-2xl overflow-hidden text-xs" data-id="element-280">
            <thead data-id="element-281">
              <tr className="border-b-2" style={{
              borderColor: 'rgba(2,132,199,0.1)'
            }} data-id="element-282">
                <th className="px-4 py-3.5 text-left font-bold text-gray-400 uppercase tracking-wide text-[10px]" data-id="element-283">
                  Incluye
                </th>
                <th className="px-4 py-3.5 text-center font-black text-gray-700 border-l border-gray-100 text-[11px]" data-id="element-284">
                  ✅ Médico en
                  <br data-id="element-285" />
                  Proceso™
                </th>
                <th className="px-4 py-3.5 text-center font-black border-l border-gray-100 text-[11px]" style={{
                color: '#0284c7',
                backgroundColor: 'rgba(224,242,254,0.6)'
              }} data-id="element-286">
                  ⭐ Carrera
                  <br data-id="element-287" />
                  Organizada™
                </th>
                <th className="px-4 py-3.5 text-center font-black border-l border-gray-100 text-[11px]" style={{
                background: 'linear-gradient(180deg, rgb(186,230,253) 0%, rgb(224,242,254) 100%)',
                color: '#0369a1'
              }} data-id="element-288">
                  🏆 Gestión
                  <br data-id="element-289" />
                  Académica™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-290">
              {rows.map((row, i) => <tr key={row.feature} className={i < rows.length - 1 ? 'border-b border-gray-100' : ''} data-id="element-291">
                  <td className="px-4 py-3 font-semibold text-gray-800" data-id="element-292">
                    {row.feature}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100 bg-gray-50/50" data-id="element-293">
                    {row.a ? <Check data-id="element-294" /> : <Dash data-id="element-295" />}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgba(224,242,254,0.4)'
              }} data-id="element-296">
                    {row.b ? <Check data-id="element-297" /> : <Dash data-id="element-298" />}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgb(240,249,255)'
              }} data-id="element-299">
                    {row.c ? <Check data-id="element-300" /> : <Dash data-id="element-301" />}
                  </td>
                </tr>)}

              {/* Price row */}
              <tr className="border-t-2" style={{
              borderColor: 'rgba(2,132,199,0.2)'
            }} data-id="element-302">
                <td className="px-4 py-3.5 text-[11px] font-black text-gray-900 uppercase tracking-wide" data-id="element-303">
                  Precio
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100 bg-gray-50/50" data-id="element-304">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-305">
                    $58.990
                  </div>
                  <div className="font-black text-gray-900 text-sm" data-id="element-306">
                    $22.950
                  </div>
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgba(224,242,254,0.4)'
              }} data-id="element-307">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-308">
                    $102.990
                  </div>
                  <div className="font-black text-sm" style={{
                  color: '#0284c7'
                }} data-id="element-309">
                    $29.950
                  </div>
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgb(240,249,255)'
              }} data-id="element-310">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-311">
                    $149.990
                  </div>
                  <div className="font-black text-sm" style={{
                  color: '#0369a1'
                }} data-id="element-312">
                    $34.950
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-313">
          <a href="#pricing" onClick={() => trackCustom('CTAClick', {
          cta_location: 'pro_business',
          cta_label: 'Elegir Nivel'
        })} className="inline-block text-white text-sm font-black rounded-xl px-8 py-4 no-underline transition-opacity hover:opacity-90" style={{
          background: 'linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%)',
          boxShadow: 'rgba(2,132,199,0.35) 0px 6px 25px 0px'
        }} data-id="element-314">
            → ELEGIR MI NIVEL AHORA
          </a>
          <p className="text-xs text-gray-400 font-medium mt-2 m-0" data-id="element-315">
            Garantía de 7 días · Acceso inmediato · 100% digital
          </p>
        </div>
      </div>

      {/* Degradé de integración con Guarantee */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(248,251,255) 100%)'
    }} data-id="element-316" />
    </section>;
}